// Vaccination status counts returned by GET /outbreaks/:outbreakId (om_api).
// The API includes these fields only for respiratory outbreaks, and the staff
// fields only when the caller has ROLE_ADMIN_STAFF — presence of a field on the
// payload is the contract for whether it should be displayed.
export const VACCINATION_COUNT_FIELDS = [
  { key: "residentCovidVaccinatedCount", label: "COVID-19 Vaccinated (Residents)", staffOnly: false },
  { key: "residentInfluenzaVaccinatedCount", label: "Influenza Vaccinated (Residents)", staffOnly: false },
  { key: "staffCovidVaccinatedCount", label: "COVID-19 Vaccinated (Staff)", staffOnly: true },
  { key: "staffInfluenzaVaccinatedCount", label: "Influenza Vaccinated (Staff)", staffOnly: true }
];

export function visibleVaccinationCounts(record, isAdminStaff) {
  return VACCINATION_COUNT_FIELDS.filter(field => record[field.key] !== undefined)
    .filter(field => !field.staffOnly || isAdminStaff)
    .map(field => ({ label: field.label, value: record[field.key] }));
}
